import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Phone, Shield, Brain, ArrowRight } from "lucide-react";

const products = [
  { icon: Brain, key: "skyglobalAi", color: "text-purple-600", bgColor: "bg-purple-50" },
  { icon: Shield, key: "secure", color: "text-red-600", bgColor: "bg-red-50" },
  { icon: Phone, key: "smartLiving", color: "text-textBlue", bgColor: "bg-blueLight" },
];

const ProductsSection = () => {
  const { t } = useTranslation();

  return (
    <section id="products" className="py-24 tablet:py-20 px-6 mobile:px-4 bg-surface hairline scroll-mt-24">
      <div className="container-page">
        <div className="mb-14 max-w-3xl">
          <span className="kicker mb-4">{t("products.label")}</span>
          <h2 className="text-4xl tablet:text-3xl mobile:text-2xl font-semibold tracking-[-0.02em] text-black">
            {t("products.title")}
          </h2>
        </div>

        <div className="grid grid-cols-3 tablet:grid-cols-1 gap-6">
          {products.map((product) => {
            const Icon = product.icon;
            return (
              <Link
                key={product.key}
                to={`/products/${product.key}`}
                className="group flex flex-col rounded-xl border border-line bg-white p-8 transition-[border-color,box-shadow,transform] duration-300 hover:border-textBlue hover:shadow-lift hover:-translate-y-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-textBlue focus-visible:ring-offset-2"
              >
                <span className={`${product.bgColor} w-12 h-12 rounded-xl flex items-center justify-center mb-5`}>
                  <Icon className={`w-6 h-6 ${product.color}`} aria-hidden="true" />
                </span>
                <h3 className="text-lg font-semibold text-black mb-2 tracking-[-0.01em]">
                  {t(`products.${product.key}.title`)}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed mb-6 flex-1">
                  {t(`products.${product.key}.description`)}
                </p>
                <span className="inline-flex items-center gap-2 text-sm font-medium text-textBlue">
                  {t("products.viewMore")}
                  <ArrowRight
                    className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1"
                    aria-hidden="true"
                  />
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
